import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

const firebaseConfig = require(process.env.VUE_APP_GCP_ACCOUNT);
firebase.initializeApp({ ...firebaseConfig });
const db = firebase.firestore();
const storage = firebase.storage().ref();
const storageWebCam = firebase.storage().refFromURL(String(process.env.VUE_APP_FIRESOTRAGE_WEBCAM_BUCKET_URL));

export { db, firebase, storage, storageWebCam, firebaseConfig };
